import React from 'react';
import Styled from './Styled';
import { Skeleton } from 'antd';
const Button = ({ width, height, ...buttonProps }) => (React.createElement(Styled.ButtonWrapper, { width: width, height: height },
    React.createElement(Skeleton.Button, Object.assign({}, buttonProps))));
export default Button;
